// get singlar or plural label based on provided value
export const pluralize = (value: number, textSingular: string, textPlural: string): string =>
  value === 1 ? textSingular : textPlural;
